import { memo, useRef, useState } from "react";
import clsx from "clsx";
import moment from "moment";
import {isEqual, isFunction} from 'lodash';
import IconButton from "@mui/material/IconButton";
import { useDailyCalendarTileStyles } from "./dailyCalendarTileStyles";
import Typography from "@mui/material/Typography";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Grid from "@mui/material/Grid";
import {isBarContextState, lockAppointmentSlot} from '../../../../../../../store/reducers/appointments';
import {useDispatch, useSelector} from 'react-redux';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LockSlotConfirmation from '../../../../modals/lockSlotConfirmation';
import useOpenState from '../../../../../../../hooks/useOpenState';
import {getConfig} from '../../../../../../../util/configUtil';

const AvailableSlotTile = ({
  event,
  onClickAvailableSlot,
}) => {
  const dispatch = useDispatch();
  const classes = useDailyCalendarTileStyles();
  const isBarsContextActive = useSelector(isBarContextState);
  const rootRef = useRef();

  const disableActionsEnabled = getConfig('modules.scheduler.disableActionsAfterNow', false);
  const disableActionsMinutes = getConfig('modules.scheduler.disableActionsAfterMinutes', 5);

  const canCancelSlot = disableActionsEnabled ? moment(event?.slot?.startDate).isAfter(moment().subtract(disableActionsMinutes, 'minute')) : true;

  const [buttonVisible, setButtonVisible] = useState(false);
  const [isOpen, open, close] = useOpenState(false, true);

  const onMouseLeave = () => {
    if (canCancelSlot) {
      setButtonVisible(false);
    }
  };

  const onMouseEnter = (e) => {
    if(!isBarsContextActive && canCancelSlot) setButtonVisible(true);
  };

  const onLockSlot = (e) => {
    e.stopPropagation();
    if (canCancelSlot) {
      // dispatch(lockAppointmentSlot(event));
      open();
    }
  }

  return (
    <div
      ref={rootRef}
      id={`${event.session.sessionId}${moment(event?.slot?.startDate).format("HH:mm")}`}
      className={clsx(classes.availableSlot, classes.animation)}
      onMouseLeave={onMouseLeave}
      onMouseEnter={onMouseEnter}
    >
      <Grid
        gap={1}
        container
        alignItems="center"
        flexDirection="column"
        justifyContent="center"
      >
        {event?.slot?.endDate && event?.slot?.startDate && (
            <Typography variant="h6" fontWeight={600} color="#ACAFB3">
              {moment(event?.slot?.startDate).format("HH:mm")} {" - "}
              {moment(event?.slot?.endDate).format("HH:mm")}
            </Typography>
        )}

        {buttonVisible && (
          <Grid
            gap={1}
            container
            alignItems="center"
            justifyContent="center"
            className={classes.iconButtonsContainer}
          >
            <IconButton className="assign" onClick={onClickAvailableSlot}>
              <AddCircleOutlineIcon />
            </IconButton>

            <IconButton onClick={onLockSlot}>
              <LockOutlinedIcon />
            </IconButton>
          </Grid>
        )}

        {isOpen && <LockSlotConfirmation open={isOpen} onAccept={reason => dispatch(lockAppointmentSlot(event, reason, close))} onClose={close}/>}
      </Grid>
    </div>
  );
};

export default memo(AvailableSlotTile, isEqual);
